export default __webpack_public_path__ + "static/media/login-wallpaper.51f4c00d.jpg";